// extracted by mini-css-extract-plugin
export default {"sticky":"NetIncomeForm_sticky__uZIZK","stickyDisabled":"NetIncomeForm_stickyDisabled__Ssxf9"};